import { Injectable } from '@angular/core';
import { CHttp } from '../../core/services/chttp.service';
import { config } from '../../app.config';

@Injectable()
export class CouponsService {
  constructor(private http: CHttp) { }

  public getAllCoupons() {
    return this.http.get(config.api_url + 'coupons');
  }

  public addCoupon(data: any) {
    return this.http.post(config.api_url + 'coupons', data);
  }

  public importCoupon(data: any) {
    return this.http.post(config.api_url + 'coupons/import', data);
  }

  public deleteCoupon(id: string) {
    return this.http.delete(config.api_url + 'coupons/' + id);
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/coupons/services/coupons.service.ts